export default "__VITE_ASSET__aI$nNuzk__"